import { defaultHttpClient } from '../../httpClient';
import type { GetAlarmSettingsResponse } from './types';

export const getAlarmSettings = async () => {
  return defaultHttpClient
    .request<GetAlarmSettingsResponse>({
      method: 'GET',
      url: '/api/v2/members/me/notification-agreements/',
    })
    .then(result => result.data);
};
